import { ETradingView } from '@trader/types';

export const tradingViewTypes = [ETradingView.Advanced, ETradingView.Classic];
